/**
 * @file   src\messages\validationMessages.ts
 * @brief  This file is responsible for define validation messages.
 * @date   June, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */

export const CommonMessages = {
    name_required: 'Enter Name.',
    phone_required: 'Enter Phone Number.',
    phone_invalid: 'Enter a valid Phone Number.',
    email_required: 'Enter Email Address.',
    email_invalid: 'Enter a valid Email Address.',
    referral_invalid: 'Enter a valid Referral Code.',
    referral_valid: 'Valid Referral Code.',
    bay: 'Select Bay Type/Number.',
    location_required: 'Select a location to proceed.',
    otp_required: 'Enter Verification Code.',
    promocode_invalid: 'Invalid Promo Code.',
    promocode_valid: 'Valid Promo Code.',
    cardnumber_required: 'Enter Card Number.',
    cardnumber_invalid: 'Enter a valid Card Number.',
    cardexpiry_required: 'Enter Expiry Date.',
    cardexpiry_invalid: 'Enter a valid Expiry Date.',
    cvv_required: 'Enter CVV.',
    cvv_invalid: 'Enter a valid CVV.',
    cardname_required: 'Enter Name on Card.',
    subject_required: 'Enter Subject.',
    message_required: 'Enter Message.',
    otp_check_required: 'You must agree to request an OTP message.',
    exp_month_required: 'Expiration month is required.',
    month_linit: 'Month must be between 1 and 12.',
    exp_year_required: 'Expiration year is required.',
    future_date_needed: 'Expiration date cannot be in the past.',
    exp_today_subscription: 'You have used all your car washes for today in your subscription.',
    no_wahses_remaining: 'Your subscription is active, but you have no washes remaining.',
    no_wash_time_remaining: 'Your subscription is active, but you have no wash time remaining.',
    no_freevauum_remaining:'Your subscription is active, but you have no vacuum sessions remaining.',
    no_freeselfserve_remaining:'Your subscription is active, but you have no free self serve sessions remaining.',
    no_loc_permission: 'Please allow the Location permission for the app and try again.',
    bay_closed: 'The selected tunnel is currently closed. Please try again later.',
    washPackageError:'Your current subscription is not supported in this bay. Please move to another bay.',
    make_required:'Enter Make',
    model_required:'Enter Model',
    color_required:'Enter Color',
    LicensePlatNumber_required:'Enter License Plate Number',
    signup_for_familycode_error: 'This number is already registered. Please sign in instead of signing up.',
    washCategoryError:'This wash category is not supported in this bay. Please move to another bay.',
};
